import React, { useState } from 'react';
import {
  InfoContainer,
  InfoWrapper,
  InfoRow,
  Column1,
  Column2,
  BookRow,
  BookDescription,
  BookDetails,
  BookThumbnailImage,
  BookTitle,
  LibraryButton,
  Heading,
  CardContainer
} from './ExampleElements';
import example0 from '../../stories/example_0.json'
// import example1 from '../../stories/example_1.json'
import example2 from '../../stories/example_2.json'
import StoryTellerModal from '../StoryTeller';

const InfoSectionExample = ({
  lightBg,
  imgStart,
  id,
  primary,
}) => {
  const [isStoryTellerOpen, setIsStoryTellerOpen] = useState(false);
  const [selectedStory, setSelectedStory] = useState('');

  const handleStoryModal = (e, story) => {
    e.preventDefault();
    setSelectedStory(story)
    setIsStoryTellerOpen(true)
  }

  return (
    <>
      <InfoContainer lightBg={lightBg} id={id}>
        <Heading style={{ justifyContent: 'center' }}>Check Out These Stories We Feel Examples</Heading>
        <CardContainer>
          <BookRow key={1} className="story-item">
            <BookThumbnailImage src={example0.img} />
            <BookDescription className="story-details">
              <BookTitle>{example0.title}</BookTitle>
              <BookDetails>{example0.description}</BookDetails>
              <LibraryButton onClick={(e) => handleStoryModal(e, example0)}>Play</LibraryButton>
            </BookDescription>
          </BookRow>
          <BookRow key={2} className="story-item2">
            <BookThumbnailImage src={example2.img} />
            <BookDescription className="story-details2">
              <BookTitle>{example2.title}</BookTitle>
              <BookDetails>{example2.description}</BookDetails>
              <LibraryButton onClick={(e) => handleStoryModal(e, example2)}>Play</LibraryButton>
            </BookDescription>
          </BookRow>
        </CardContainer>
      </InfoContainer>
      <StoryTellerModal isOpen={isStoryTellerOpen} onClose={() => setIsStoryTellerOpen(false)} story={selectedStory} firstPage={0} />
    </>
  );
};

export default InfoSectionExample;
